var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { isUserAuthorised } from '../../Hooks/usePermissionLoader';
export var PermissionsCheck = function (props) {
    var isAuthorised = isUserAuthorised(props.permission);
    if (isAuthorised)
        return props.children;
    if (props.alternate)
        return props.alternate;
    return null;
};
var MassPermissionsCheck = /** @class */ (function (_super) {
    __extends(MassPermissionsCheck, _super);
    function MassPermissionsCheck() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MassPermissionsCheck.prototype.render = function () {
        var permissionResults = Object.entries(this.props.permissions).reduce(function (currentPermissions, nextPermissions) {
            var _a;
            return __assign(__assign({}, currentPermissions), (_a = {}, _a[nextPermissions[0]] = isUserAuthorised(nextPermissions[1]), _a));
        }, {});
        return this.props.render(permissionResults);
    };
    return MassPermissionsCheck;
}(React.Component));
export { MassPermissionsCheck };
export function withPermissionCheck(WrappedComponent, permission, muiName, alternate) {
    var _a;
    return _a = /** @class */ (function (_super) {
            __extends(class_1, _super);
            function class_1() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            class_1.prototype.render = function () {
                var permissionProp = this.props.permission
                    ? this.props.permission
                    : permission;
                var alternateProp = this.props.alternate ? this.props.alternate : alternate;
                if (WrappedComponent) {
                    if (permissionProp)
                        return (React.createElement(PermissionsCheck, { permission: permissionProp, alternate: alternateProp },
                            React.createElement(WrappedComponent, __assign({}, this.props))));
                    throw new Error('withPermissionCheck used with out any permission passed in');
                }
                return null;
            };
            return class_1;
        }(React.Component)),
        _a.muiName = muiName,
        _a;
}
